import { render, staticRenderFns } from "./change-pwd.vue?vue&type=template&id=6c414e0c&scoped=true&"
import script from "./change-pwd.vue?vue&type=script&lang=js&"
export * from "./change-pwd.vue?vue&type=script&lang=js&"
import style0 from "./change-pwd.vue?vue&type=style&index=0&id=6c414e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c414e0c",
  null
  
)

export default component.exports